export const SCRIPTING_AUDIO_TRACK_NAME = "workadventure-scripting-audio";
